export const HEADER_HEIGHT = 52;
export const MAX_PRODUCT_PROPOSALS = 80;
export const JUMP_TOOLTIP_DURATION_MS = 1500;
export const MISSING_IMAGE_PLACEHOLDER =
  "https://placehold.co/400x500/E6EBEF/8695A8/png?text=Image+Missing";

export const SCROLL_SPEED_OPTIONS = [
  "slow",
  "medium",
  "fast",
  "plaid",
] as const;
export type ScrollSpeed = (typeof SCROLL_SPEED_OPTIONS)[number];
export const SCROLL_SPEED_STEPS: Record<ScrollSpeed, number> = {
  slow: 2,
  medium: 3,
  fast: 5,
  plaid: 10,
};
export const DEFAULT_SCROLL_SPEED: ScrollSpeed = "fast";
export const SCROLL_SPEED_STORAGE_KEY = "track-labeling.scroll-speed";
